import { forwardRef } from 'react';

export const AvgSMPricePerRegionIcon = forwardRef<
  SVGSVGElement,
  React.HTMLAttributes<SVGSVGElement>
>(function Icon(props, ref) {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 113.4 113.4"
      ref={ref}
      xmlSpace="preserve"
      {...props}
    >
      <style>
        {
          '.st3{fill:none;stroke:#004b54;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}'
        }
      </style>
      <path
        className="st3"
        d="M44.2 63.2c-.4.1-.7.1-1.1.1-3.5 0-6.3-2.9-6.3-6.4s2.8-6.4 6.3-6.4c.4 0 .8 0 1.1.1M36 55.3h5.1M36 58.7h5.1M48.1 64.7l5.3-15.3M57.2 55.9v6.3M57.2 55.9c0-1.7 1.4-3.2 3.2-3.2 1.7 0 3.2 1.4 3.2 3.2"
      />
      <path
        className="st3"
        d="M63.5 55.9c0-1.7 1.4-3.2 3.2-3.2 1.7 0 3.2 1.4 3.2 3.2M69.8 55.9v6.3M63.5 55.9v6.3M73.1 55.5h4.2M75.8 53.2l-2.7 2.3M73 51.3c0-1.1.9-1.9 1.9-1.9 1.3 0 1.9.9 1.9 1.9 0 .8-.5 1.2-.8 1.6l-.4.4"
      />
      <path
        style={{
          fill: 'none',
          stroke: '#004b54',
          strokeWidth: 2.6,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
        }}
        d="M24.9 24.9h63.6v63.6H24.9z"
      />
    </svg>
  );
});
